import { render, staticRenderFns } from "./zhgl.vue?vue&type=template&id=2309ad9d&"
import script from "./zhgl.vue?vue&type=script&lang=js&"
export * from "./zhgl.vue?vue&type=script&lang=js&"
import style0 from "./zhgl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports